/** Sieve — entry point. Boots the app and registers the PWA service worker. */

import './styles.css';
import { App } from './ui/app';

const root = document.getElementById('app');
if (!root) throw new Error('#app root not found');

const app = new App(root);
void app.init().catch((err) => {
  console.error(err);
  root.textContent = 'Something went wrong loading Sieve. Please reload.';
});

// PWA registration is injected by vite-plugin-pwa (autoUpdate). The virtual
// module is only present in a real build, so we import it lazily and ignore it
// during `vite dev`/tests.
if (import.meta.env.PROD) {
  import('virtual:pwa-register')
    .then(({ registerSW }) => registerSW({ immediate: true }))
    .catch(() => {
      /* offline support unavailable — the game still works online */
    });
}
